import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import { productStartUpdate } from '../../../../actions/products'
import { sellStartDeleted, sellStartUpdate } from '../../../../actions/sell'
import { uiOpenModal } from '../../../../actions/ui'


export const SellCards = ({venta}) => {

    const { productsDB } = useSelector(state => state)
    let infoProduct =[]

  
      
        venta.items.map( item => {
            productsDB.map(product => {
                if( product.id === item.id){
                    infoProduct.push(product)
                }
               
            } )
        })
    
    


    venta = {...venta,infoProduct}

    
    // console.log(venta)
    const dispatch = useDispatch()
    
const handleSelect = (e) => {

        let newInfoProduct = []

        if(e.target.value === "entregado"){

            infoProduct.map(product => 
                newInfoProduct.push({
                    ...product,
                    sell: true
                }))
        }else if(e.target.value === "pendiente" || e.target.value === "confirmado"){
            infoProduct.map(product => 
                newInfoProduct.push({
                    ...product,
                    sell: false
                }))

        }

        newInfoProduct.map(product =>{
            dispatch(productStartUpdate(product))
        })

     

const newVenta = {
    ...venta,
    estado: e.target.value
}


    dispatch(sellStartUpdate(newVenta))

 }

 const handleDelete = () => {
    Swal.fire({
        title: 'Quieres eliminar esta venta?',
        icon: 'warning',
        showDenyButton: true,
        // showCancelButton: true,
        confirmButtonText: 'Eliminar',
        denyButtonText: `Cancelar`,
    }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
            dispatch(sellStartDeleted(venta))
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Venta Eliminado',
                showConfirmButton: false,
                timer: 1500
              })
         
        } else if (result.isDenied) {
            Swal.fire({
                position: 'center',
                icon: 'info',
                title: 'La venta NO ah sido eliminado',
                showConfirmButton: false,
                timer: 1000
              })
        }
      })

 }

 const handleVentaModal = (venta) =>{

    // console.log(item)
    dispatch( uiOpenModal(venta) )
}
 


    return (
      <>

        
        
        <td>{venta.tramite}</td>
        <td>{venta.usuario.name}</td>
        {/* <td>{venta.usuario.id}</td> */}
        <td>

                <select name="" id="" onChange={handleSelect}>

                    <option value={venta.estado}>{venta.estado}</option>
                    

                        {venta.estado === "pendiente" &&
                        <>
                            <option value="confirmado">Confirmado</option>
                            <option value="entregado">Entregado</option>
                        </>
                        }

                        {venta.estado === "confirmado" &&
                        <>
                            <option value="pendiente">Pendiente</option>
                            <option value="entregado">Entregado</option>
                        </>
                        }
                        {venta.estado === "entregado" &&
                        <>
                            <option value="pendiente">Pendiente</option>
                            <option value="confirmado">Confirmado</option>
                        </>
                        }
            

                </select>

            
        </td>
        <td>{venta.mpResponse.status}</td>
        <td> <a href="" target="_blank"><i className="fa-brands fa-steam"></i></a> </td>
        <td><i className="fa-solid fa-circle-info" onClick={() => handleVentaModal(venta)}></i></td>
        <td>$ {venta.mpResponse.transaction_amount}</td>
        <td><i className="fa-solid fa-trash-can" onClick={handleDelete}></i></td>
     
 
      
      </>
    
    )

}
